













































































































































import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'node_modules/vue-router/types';
import { IIssue, IAttachment, ILogwork, IProject } from '@/lib/interfaces';
import {
  getIssue,
  updateIssue,
  addIssueAttachments,
  deleteIssueAttachment,
  deleteIssueLogwork,
  getProject,
} from '@/services/api.service';
import SupSelect from '@/components/select/SupSelect.vue';
import { updateAllIssue } from '@/lib/helpers/issue.helper.ts';
import IssueStatusSelect from '@/components/select/IssueStatusSelect.vue';

@Component({
  components: {
    SupSelect,
    IssueStatusSelect,
  },
  sockets: {
    issueUpdated(this: IssueEditor, newIssue: IIssue) {
      updateAllIssue(this.issue, newIssue);
    },
  },
})
export default class IssueEditor extends Vue {
  // TODO: вынести slider в отдельный компонент
  /** Текущий issue */
  private issue: IIssue = {
    title: '',
    priority: 0,
    deleted: false,
    project: {
      _id: '',
      title: '',
      key: '',
    },
    _creator_id: '',
    code: 0,
    comments: [],
  };
  private project: IProject = {
    key: '',
    shared_code: 0,
    title: '',
    managers: [],
    customer: {
      _id: '',
      name: '',
    },
  };
  /** Labels for slider */
  private priorMarks = {
    0: {
      label: 'Низкий',
      style: {
        width: '8px',
        height: '8px',
        display: 'block',
        backgroundColor: 'green',
        transform: 'translate(-2px, -2px)',
      },
      labelStyle: {
        color: 'green',
      },
    },
    5: {
      label: 'Средний',
      style: {
        width: '8px',
        height: '8px',
        display: 'block',
        backgroundColor: 'orange',
        transform: 'translate(-2px, -2px)',
      },
      labelStyle: {
        color: 'orange',
      },
    },
    10: {
      label: 'Высокий',
      style: {
        width: '8px',
        height: '8px',
        display: 'block',
        backgroundColor: 'red',
        transform: 'translate(-2px, -2px)',
      },
      labelStyle: {
        color: 'red',
      },
    },
  };
  /** Issue до изменений */
  private cachedIssue: IIssue = { ...this.issue };

  /** Color for slider */
  private processStyle() {
    return [
      [0, 30, { backgroundColor: 'green' }],
      [31, 70, { backgroundColor: 'orange' }],
      [71, 100, { backgroundColor: 'red' }],
    ];
  }
  //
  private async beforeRouteEnter(to: Route, from: Route, next: (vm?: any) => void) {
    const issue: IIssue = await getIssue(to.query.issue_id as string);
    const project: IProject = await getProject(issue.project._id as string);

    next((vm: IssueEditor) => {
      vm.issue = issue;
      vm.project = project;
      vm.$socket.emit('joinRoom', `issue-${issue._id}`);
    });
  }

  private beforeRouteLeave(to: Route, from: Route, next: (vm?: any) => void) {
    this.$socket.emit('leaveRoom', `issue-${this.issue._id}`);
    next();
  }

  /** При изменении любого поле IIssue */
  private onChangeIssueField<K extends keyof IIssue>(field: K, newValue: IIssue[K]) {
    this.cachedIssue = { ...this.issue };
    this.issue[field] = newValue;
    this.updateIssue();
  }

  /** Сохраняем изменения issue */
  private async updateIssue() {
    try {
      await updateIssue(this.issue);
    } catch (err) {
      // Возвращаем закешированные данные, не забывая про реактивность
      for (const key in this.cachedIssue) {
        if (this.cachedIssue.hasOwnProperty(key)) {
          Vue.set(this.issue, key, this.cachedIssue[key]);
        }
      }
    }
  }

  /** Когда кликнули на новый логворк */
  private onClickAddLogwork() {
    this.$router.push({
      name: 'logwork_editor',
      params: { issue_id: this.$route.query.issue_id as string },
    });
  }

  /** При нажатии на добавление нового вложения */
  private async onAddAttachments({ target }: { target: HTMLInputElement }) {
    const form = new FormData();
    if (target.files) {
      /* tslint:disable-next-line:prefer-for-of */
      for (let i = 0; i < target.files.length; i++) {
        const file = target.files[i];
        form.append('attachments', file, file.name);
      }
    }
    const attachments = await addIssueAttachments(this.issue._id!, form);
    this.issue.attachments = attachments;
  }

  /** Когда кликнули на удаление вложения */
  private async onClickDeleteAttachment(attachment: IAttachment) {
    await deleteIssueAttachment(this.issue._id!, attachment._id);
    for (const i in this.issue.attachments!) {
      if (this.issue.attachments![i]._id === attachment._id) {
        this.issue.attachments!.splice(+i, 1);
        break;
      }
    }
  }

  /** Когда кликнули на удаление вложения */
  private async onClickDeleteLogwork(logwork: ILogwork) {
    await deleteIssueLogwork(this.issue._id!, logwork._id!);
    for (const i in this.issue.logworks!) {
      if (this.issue.logworks![i]._id === logwork._id) {
        this.issue.logworks!.splice(+i, 1);
        break;
      }
    }
  }
}
